import React from 'react';
import ReactDom from 'react-dom';
import { Provider } from 'react-redux';

import ContentFeedFilters from '../Components/ContentFeedFilters/index.jsx';
import ContentFeedList from '../Components/ContentFeedList/index.jsx';
import ErrorBoundary from '../Components/ErrorBoundary/index.jsx';
import PagedData from '../Components/PagedData/index.jsx';
import ShowLocked from '../Components/ShowLocked/index.jsx';

import API from '../Services/ContentFeed/index.jsx';

import Store from '../Store/index.js';


export default function(document) {
  var element = document.getElementById('cs-content-feed');

  if (element) {
    var articleTypes = element.dataset.articleTypes;
    var author = element.dataset.author;
    var showLocked = Boolean(element.dataset.showLocked);
    var showLockedUi = Boolean(element.dataset.showLockedUi);
    var hideFilters = Boolean(element.dataset.hideFilters);
    var hideLockedSelector = Boolean(element.dataset.hideLockedSelector);
    var hideFreeArticles = Boolean(element.dataset.hideFreeArticles);
    var hidePremiumArticles = Boolean(element.dataset.hidePremiumArticles);

    if (articleTypes) {
      articleTypes = articleTypes.split(',');
    }

    if (author) {
      author = [ author ];
    }

    var api = new API(articleTypes, author);
    api.showLocked(showLocked);
    api.hideFreeArticles(hideFreeArticles);
    api.hidePremiumArticles(hidePremiumArticles);

    var WrappedComponent = PagedData(ContentFeedList, api);

    var output = [];
    if (!hideFilters && !(articleTypes || author)) {
      output.push(
        <ContentFeedFilters key="filters" api={api} />
      );
    }
    if (!hideLockedSelector && showLockedUi) {
      output.push(
        <ShowLocked key="show-locked" showLocked={showLocked} apiService={api} />
      );
    }
    output.push(
      <WrappedComponent key="component" />
    );

    ReactDom.render(
      <ErrorBoundary>
        <Provider store={Store}>
          {output}
        </Provider>
      </ErrorBoundary>,
      element
    );
  }
};

